<template>
  <mds-section collapsible :size="6" title="View Issues" class="import-lineups-result__error">
    <template #mds-section-actions>
        <mds-button variation="primary" class="abc" @click="downloadErrors">Export Issues</mds-button>
    </template>
    <mds-table row-hover>
      <mds-thead>
          <mds-th style="width: 75px;"> Row No </mds-th>
          <mds-th style="width: 250px;"> Error Type </mds-th>
          <mds-th> Error Message </mds-th>
      </mds-thead>
      <mds-tbody>
          <mds-tr  v-for="(row, i) in formattedErrorData" :key="i">
              <mds-td> {{row.rowNumber}} </mds-td>
              <mds-td> {{row.errorType}} </mds-td>
              <mds-td> {{row.errorMessage}} </mds-td>
          </mds-tr>
      </mds-tbody>
    </mds-table>
  </mds-section>
</template>
<script>

import MdsSection from '@mds/section';
import {
  MdsTable, MdsThead, MdsTh, MdsTbody, MdsTr, MdsTd,
} from '@mds/data-table';
import { exportExcel } from '@/utils/misc';

export default {
  name: 'import-error-table',
  components: {
    MdsSection,
    MdsTable,
    MdsThead,
    MdsTh,
    MdsTbody,
    MdsTr,
    MdsTd,
  },
  props: {
    errorData: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
    };
  },
  methods: {
    downloadErrors() {
      exportExcel(this.formattedErrorData, 'Import_Validation_Issues');
    },
  },
  computed: {
    formattedErrorData() {
      const flatErrorData = [];
      this.errorData.forEach((errorRow) => {
        errorRow.errors.forEach((error, i) => {
          const formattedError = {
            rowNumber: errorRow.rowIdentifier.rowNumber,
            secId: errorRow.secId,
            errorType: error,
            errorMessage: errorRow.messages[i],
          };
          flatErrorData.push(formattedError);
        });
      });
      return flatErrorData;
    },
  },
};
</script>
<style lang="scss" scoped>
.import-lineups-result__error {
  margin-bottom: $mds-space-1-x;
}
</style>
